export const formatPhone = (phone) => {
    if (!phone) return '-';

    phone = phone.toString();

    // Remove all non-digits
    phone = phone.replace(/\D/g, '');

    // India number with country code
    if (phone.length === 12 && phone.startsWith('91')) {
        return `+91 ${phone.slice(2, 7)} ${phone.slice(7)}`;
    }

    // India number without country code
    if (phone.length === 10) {
        return `+91 ${phone.slice(0, 5)} ${phone.slice(5)}`;
    }

    return phone;
};
